/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 14:47:42
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHOC/index.tsx
 */
import React, { useState, ReactNode } from 'react';
import css from './css.module.less';

//import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
//import { store } from 'src/store';

import { SectionCollapse } from '@/src/components/Antd';
import SectionTitle from 'src/layout/EditorPageLayout/SectionTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import { Modal } from 'src/components/Antd';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const SectionHOC = (Component: any, obj) => {
  const {
    id,
    getCollapse,
    isNotRedux,
    title: _title,
    Title,
    onCollapseChange,
    collapseProps,
    cannotCollapse,
    sectionTitleClassName,
    containerClassName,
    useDefaultSectionClassName,
    useCustomCollapseTitle,
    useDefaultCollapseContent,
  } = obj;

  const WrappedComponent = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const title = Title ? <Title {...props} /> : _title;
    const _d = useDispatch();
    const _open = getCollapse
      ? isNotRedux
        ? getCollapse(id)
        : useSelector(getCollapse(id))
      : true;
    const handleOnCollapseChange = (status) => {
      if (onCollapseChange) {
        if (isNotRedux) {
          onCollapseChange({ id, status });
        }
        _d(onCollapseChange({ id, status }));
      }
    };
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
    const onModalCancel = () => {
      setShowModal(false);
    };
    const [modalContent, setModalContent] = useState<ReactNode>('');
    const _props = {
      setShowModal,
      setModalTitle,
      setModalContent,
      onModalCancel,
      ...props,
    };
    const _r = React.useMemo(() => {
      if (!cannotCollapse) {
        return (
          <SectionCollapse
            open={_open}
            key={id}
            id={id}
            //titleStyle={i.style}
            title={
              !useCustomCollapseTitle ? <SectionTitle title={title} /> : title
            }
            content={
              useDefaultCollapseContent ? (
                <SectionContent>
                  <Component {..._props} />
                </SectionContent>
              ) : (
                <Component {..._props} />
              )
            }
            openMargin={16}
            onClickTrigger={handleOnCollapseChange}
            {...(collapseProps || {})}
          />
        );
      } else {
        return (
          <Element>
            <SectionWrapper
              sectionTitleClassName={sectionTitleClassName}
              containerClassName={`${
                useDefaultSectionClassName ? '' : css.containerClassName
              } ${containerClassName || ''} `}
              title={title}
              id={id}>
              <Component {..._props} />
            </SectionWrapper>
          </Element>
        );
      }
    }, [cannotCollapse, _open, props, collapseProps, title]);

    return (
      <React.Fragment>
        <Modal
          width={600}
          visible={showModal}
          title={modalTitle}
          onCancel={onModalCancel}
          cancelText={getI18n('general.cancel')}>
          {modalContent}
        </Modal>
        {_r}
      </React.Fragment>
    );
  };
  return WrappedComponent;
};
export default SectionHOC;
